import React from "react";
import useBrandRanking from "../../../query/useBrandRanking";
import BrandRankingHorizontalList from "./BrandRankingHorizontalList";

const FILTERS = {
  popular: "topTrendingBrands1w",
  rising: "risingTrendingBrands1w",
  emerging: "emergingTrendingBrands1w",
};

/**
 * 주간 랭킹 페이지
 * @returns {Element}
 * @constructor
 */
export default function WeekRankingPage() {
  const { brands: popular } = useBrandRanking(FILTERS.popular);
  const { brands: rising } = useBrandRanking(FILTERS.rising);
  const { brands: emerging } = useBrandRanking(FILTERS.emerging);

  return (
    <>
      <BrandRankingHorizontalList title="모두에게 사랑받는 브랜드" brands={popular} />
      <BrandRankingHorizontalList title="요즘 뜨는 브랜드" brands={rising} />
      <BrandRankingHorizontalList title="주목받기 시작한 브랜드" brands={emerging} />
    </>
  );
}
